(() => {
  'use strict';
  if (window.PortafotoLang === 'en') return;

  const isCollectionPage = () =>
    document.body.classList.contains('template-collection') ||
    window.location.pathname.indexOf('/collections/') === 0;

  const displayTitle = (raw) => {
    const title = (raw || '').replace(/\s+/g, ' ').trim();
    if (!title) return title;

    const patterns = [
      {
        re: /^set\s+of\s+three(?:\s*[_-]\s*|\s+)?(\d+)?$/i,
        label: 'طقم ٣ براويز فنية'
      },
      {
        re: /^set\s+of\s+two(?:\s*[_-]\s*|\s+)?(\d+)?$/i,
        label: 'طقم بروازين فني'
      },
      {
        re: /^gallery\s+walls?(?:\s*[_-]\s*|\s+)?(\d+)?$/i,
        label: 'مجموعة حائط'
      },
      {
        re: /^framed\s+canvas(?:\s*[_-]\s*|\s+)?(\d+)?$/i,
        label: 'لوحة كانفاس بإطار'
      }
    ];

    for (const item of patterns) {
      const match = title.match(item.re);
      if (match) return match[1] ? `${item.label} — تصميم ${match[1]}` : item.label;
    }

    return title;
  };

  const cleanCardTitles = () => {
    document.querySelectorAll('.card-title[data-product-title]').forEach((anchor) => {
      const original = anchor.getAttribute('data-product-title') || '';
      const mapped = displayTitle(original);
      if (!mapped || mapped === original.trim()) return;

      const variantSpan = anchor.querySelector('[data-change-title]');
      let textNode = Array.from(anchor.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
      );
      if (!textNode) {
        textNode = document.createTextNode('');
        anchor.insertBefore(textNode, anchor.firstChild);
      }
      textNode.nodeValue = `${mapped}${variantSpan ? ' ' : ''}`;
      if (variantSpan) variantSpan.style.display = 'none';
      anchor.setAttribute('title', mapped);
      anchor.dataset.portafotoDisplayTitle = mapped;
    });
  };

  const cleanPdpTitle = () => {
    const titleEl = document.querySelector('.productView-title');
    if (!titleEl) return;
    const original = titleEl.dataset.portafotoOriginalTitle || titleEl.textContent.trim();
    if (!titleEl.dataset.portafotoOriginalTitle) titleEl.dataset.portafotoOriginalTitle = original;
    const mapped = displayTitle(original);
    if (mapped && mapped !== original && titleEl.textContent.trim() !== mapped) {
      titleEl.textContent = mapped;
    }
  };

  const exactText = (root, from, to) => {
    if (!root) return;
    root.querySelectorAll('*').forEach((el) => {
      if (el.children.length === 0 && el.textContent.trim() === from) el.textContent = to;
    });
  };

  const simplifyCollectionToolbar = () => {
    if (!isCollectionPage()) return;
    const toolbar = document.querySelector('toolbar-item.toolbar');
    if (!toolbar) return;

    toolbar.querySelectorAll('[data-view-as-mobile]').forEach((el) => {
      const wrapper = el.closest('.toolbar-wrapper.toolbar-mobile');
      if (wrapper) wrapper.classList.add('portafoto-viewas-wrapper-hidden');
    });

    [
      ['Filter', 'فلترة'],
      ['Sort', 'ترتيب'],
      ['Sort by', 'رتّب حسب'],
      ['Sort by:', 'رتّب حسب:']
    ].forEach(([from, to]) => exactText(toolbar, from, to));
  };

  const addCollectionGuide = () => {
    if (!isCollectionPage()) return;
    const toolbar = document.querySelector('toolbar-item.toolbar');
    if (!toolbar || document.querySelector('.portafoto-collection-guide')) return;

    const guide = document.createElement('div');
    guide.className = 'portafoto-collection-guide';
    guide.textContent = 'اختار التصميم اللي عجبك — المقاس ولون الإطار هتختارهم بسهولة من صفحة المنتج.';
    toolbar.insertAdjacentElement('beforebegin', guide);
  };

  const cleanSidebar = () => {
    if (!isCollectionPage()) return;
    document.querySelectorAll('.sidebarBlock-heading').forEach((heading) => {
      const text = heading.textContent.trim().toLowerCase();
      if (text === 'featured products') {
        const block = heading.closest('.sidebarBlock');
        if (block) block.style.display = 'none';
      }
      if (text === 'categories') heading.textContent = 'تشكيلاتنا';
    });
  };

  const run = () => {
    cleanCardTitles();
    cleanPdpTitle();
    simplifyCollectionToolbar();
    addCollectionGuide();
    cleanSidebar();
  };

  const boot = () => {
    run();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        run();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
